export default "__VITE_ASSET__aKo4wVjMjV9S8rY28E5Mvg__ 480w, __VITE_ASSET__K0d7Xv_kmrg9pjrMnixeoA__ 745w";